import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';
import { ImageField, ImageInput, useNotify, useTranslate } from 'react-admin';
import { useForm } from 'react-final-form';
import { serverApiUrl } from '../../config/constants';
import httpClient from '../../core/httpClient';
import { fileUploadStyles } from './styles';

const useStyles = makeStyles(fileUploadStyles);

const UploadImageInput = (props) => {
  const {
    label,
    imageInputSource,
    imagePreviewSource = 'photo',
    uploadType,
    noLabel,
    ...rest
  } = props;

  const form = useForm();
  const translate = useTranslate();
  const notify = useNotify();
  const classes = useStyles();
  const [imagePreview, setImagePreview] = useState();

  useEffect(() => {
    const loadImage = () => {
      // Try multiple ways to get the file path
      let file_path = form.getFieldState(imageInputSource)?.value || form.getState()?.values?.[imageInputSource];

      // Handle nested array access like slider_images[2].image
      if (!file_path && imageInputSource.includes('[') && imageInputSource.includes(']')) {
        const formValues = form.getState()?.values;
        if (formValues) {
          // Parse the path like "slider_images[2].image"
          const match = imageInputSource.match(/^([^[]+)\[(\d+)\]\.(.+)$/);
          if (match) {
            const [, arrayName, index, fieldName] = match;
            const arrayValue = formValues[arrayName];
            if (arrayValue && arrayValue[parseInt(index, 10)]) {
              try {
                // Parse JSON string if it's a string
                const item =
                  typeof arrayValue[parseInt(index, 10)] === 'string'
                    ? JSON.parse(arrayValue[parseInt(index, 10)])
                    : arrayValue[parseInt(index, 10)];
                file_path = item[fieldName];
              } catch (e) {
                console.warn('Failed to parse array item:', e);
              }
            }
          }
        }
      }

      if (file_path) {
        const url = `${serverApiUrl}/services/file?file_key=${file_path}`;
        const options = { method: 'GET' };
        httpClient(url, options).then((res) => {
          setImagePreview(res.json.url);
        });
      }
    };

    // Try immediately
    loadImage();

    // Also try after a short delay in case form data isn't ready yet
    const timeoutId = setTimeout(loadImage, 100);

    return () => clearTimeout(timeoutId);
  }, [imageInputSource, form]);

  const uploadImage = (file) => {
    if (!uploadType) {
      notify('Error: Unsupported upload target', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('file', file[0]);
    formData.append('upload_type', uploadType);
    const url = `${serverApiUrl}/admin/services/file`;
    const options = { method: 'POST', body: formData };

    httpClient(url, options)
      .then((res) => {
        form.change(imageInputSource, res.json.file_key);
        setImagePreview(res.json.url);
      })
      .catch(() => {
        notify("Error: Image wasn't sent", 'warning');
      });
  };

  const formatFunc = (value) => {
    if (typeof value === 'string') {
      return { [imagePreviewSource]: imagePreview };
    }

    return value;
  };

  return (
    <ImageInput
      classes={{
        dropZone: props.noMargin ? classes.dropZoneNoMargin : classes.dropZone,
        removeButton: classes.removeButton,
      }}
      accept="image/*"
      source={imageInputSource}
      format={formatFunc}
      label={noLabel ?? label}
      placeholder={<span>{translate('root.uploadImage')}</span>}
      options={{ onDropAccepted: uploadImage }}
      {...rest}
    >
      <ImageField classes={{ image: classes.image }} source={imagePreviewSource} />
    </ImageInput>
  );
};

export default UploadImageInput;
